<template>
    <modal style="z-index: 9999;" :show="showModal" :show-close="true" @close="$store.dispatch('config/change',{customer: false, location: false})">
        <template slot="header">
            <h2 class="modal-title" id="exampleModalLabel">Wo arbeiten Sie heute?</h2>
        </template>
        <div>
            <div class="table-responsive">
                <base-table thead-classes="thead-light"
                            tbody-classes="light"
                            table-classes="scrollable"
                            :data="locations">
                    <template slot="columns">
                        <th>Standort</th>
                        <th></th>
                    </template>
                    <template v-slot="{row}">
                        <th scope="row">
                            <div v-if="$store.getters['location/isLoading']" class="loading"> </div><div v-else>{{ row.name }}</div>
                        </th>
                        <td>
                            <div v-if="$store.getters['location/isLoading']" class="loading-button"> </div><div v-else><base-button icon="ni ni-check-bold" size="sm" type="primary" @click="setLocation(row)"></base-button></div>
                        </td>
                    </template>
                </base-table>
            </div>
        </div>
    </modal>
</template>

<script>
    export default {
        name:"ChangeLocation",
        props: {
            showModal: {
                type: Boolean
            }
        },
        computed: {
            locations() {
                return (this.$store.getters['location/isReady']) ? this.$store.getters['location/showLocationCollection'] : [];
            }
        },
        methods: {
            setLocation(location) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = {location: location.id};
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/changelocation`, requestOptions)
                        .then(this.handleResponse)
                        .then(() => {
                                this.isLoading = false;
                                this.$store.dispatch('alert/success', 'Der Standort wurde geändert.');
                                this.$store.dispatch('config/change',{customer: false, location: false});
                                this.$store.dispatch('authentication/onRefresh');
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
        }
    }
</script>

<style scoped>

</style>